import { render, staticRenderFns } from "./Familia.vue?vue&type=template&id=8120ef60&scoped=true&"
import script from "./Familia.vue?vue&type=script&lang=js&"
export * from "./Familia.vue?vue&type=script&lang=js&"
import style0 from "./Familia.vue?vue&type=style&index=0&id=8120ef60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8120ef60",
  null
  
)

export default component.exports